import React, { useMemo } from 'react';
import { useAward, useMyAwardEntry, useDeleteEntry } from "./../../../../commons/customHooks/Award"

import AwardsProgressComponent from './awardsProgress';
import ParticipateInVotingComponent from './participateIVoting';
import RealTimeRankingComponent from './realTimeRanking';
import MyEntryComponent from './MyEntry';

type props = {
  tab: any
};

const RankingComponent = ({tab}: props) => {
  const [ , onDelete, , deleteSuccess ] = useDeleteEntry();
  const award_params = useMemo(() => ({limit: 10, type: "top"}), [deleteSuccess, tab])
  const [ award, entries ] = useAward(award_params);
  const [ entry ] = useMyAwardEntry(tab);

  return (
    <div id="ranking-page-award">
      <AwardsProgressComponent award={award} entry={entry} />
      <div className="line-border-bottom" />
      {entry?.id && <MyEntryComponent entry={entry} award={award} onDelete={onDelete} />}
      {entry?.id && !entry.deleted_at && <div className="line-border-bottom" />}
      <RealTimeRankingComponent entries={entries} entry={entry} award={award} />
      <div className="line-border-bottom" />
      <ParticipateInVotingComponent />
    </div>
  );
};

export default RankingComponent;
